import React, { useEffect } from 'react';
import { TableRow } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';

import { Heading, Table, Filters, TableCell } from 'comps';
import { useStudentAddOnsGetAll } from 'actions/studentsv2';
import { getFormatedDate } from 'utils';
import { trackEvent } from 'modules/analytics';
import { EVENT_TYPE } from 'constants/logger';

export default function AddOns({ userId }) {
  const { id } = useParams();
  const { data, getAll: getAddOns, isProcessing } = useStudentAddOnsGetAll(id);
  const { addons, courses } = data || {};

  useEffect(() => {
    if (!addons && !courses) getAddOns(id, { include_student_courses: true });
  }, [addons, courses, getAddOns, id]);

  useEffect(() => {
    trackEvent(EVENT_TYPE.ADD_ON_SCREEN_VIEW, {
      student_id: id,
    });
  }, []);

  const courseIdObj = {};

  courses?.forEach(({ id, course_name: courseName }) => {
    courseIdObj[id] = courseName;
  });

  addons?.forEach(data => {
    const { student_course_id: studentCourseId } = data;
    if (courseIdObj[studentCourseId]) {
      data['course_name'] = courseIdObj[studentCourseId];
    } else {
      data['course_name'] = '';
    }
  });

  function getLabel(label) {
    return label?.toLowerCase() || '-';
  }

  return (
    <>
      <Heading>Add-ons Info</Heading>
      <Filters filters={[]} />
      <Table
        headerCell={[
          { title: 'Add on name' },
          { title: 'Add on type' },
          { title: 'Course tagged' },
          { title: 'Purchased date' },
          { title: 'Duration in (months)' },
          { title: 'Comments' },
        ]}
        showLoader={isProcessing}
        dataLength={addons?.length}
        showInfo={false}
      >
        {addons?.map(addon => {
          const {
            addon_name: addonName,
            addon_type: addonType,
            course_name: courseName,
            comments,
            purchased_date: purchasedDate,
            duration,
          } = addon;
          return (
            <TableRow>
              <TableCell width={3}>{getLabel(addonName)}</TableCell>
              <TableCell width={3}>{getLabel(addonType)}</TableCell>
              <TableCell width={2}>{getLabel(courseName)}</TableCell>
              <TableCell width={2}>{getFormatedDate(purchasedDate)}</TableCell>
              <TableCell width={3}>{duration || '='}</TableCell>
              <TableCell width={2}>{getLabel(comments)}</TableCell>
            </TableRow>
          );
        })}
      </Table>
    </>
  );
}
